// extracted by mini-css-extract-plugin
export default {"container":"AdvertisementPlay_container__5H86W"};